import { ThemedSvg } from './ThemedSvg.styled'
import { IconProps } from 'core/typing/IconType'

export const EVBattery = ({ width, height, color }: IconProps) => {
  return (
    <ThemedSvg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 13">
      <rect
        x="1.33819"
        y="1.00933"
        width="17.9103"
        height="10.4182"
        rx="1.54002"
        stroke={color}
        strokeWidth="1.40002"
      />
      <path
        d="M19.2588 4.53003V4.53003C20.0206 4.53003 20.6381 5.14757 20.6381 5.90934V6.52734C20.6381 7.28912 20.0206 7.90665 19.2588 7.90665V7.90665"
        stroke={color}
        strokeWidth="1.40002"
      />
      <path
        d="M1.90332 6.46717L6.86454 6.46717L8.44569 3.24194L10.2623 8.42287L12.0285 5.1507L12.8695 6.46717H18.7988"
        stroke={color}
        strokeWidth="1.40002"
        strokeLinejoin="round"
      />
    </ThemedSvg>
  )
}
